import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", stroke: "#2574DA", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 9 6 6 6-6" }));
export default SvgChevronDown;
